export const ccbyLicenseLink = "https://creativecommons.org/licenses/by/3.0/";
